import { render, staticRenderFns } from "./messageIndex.vue?vue&type=template&id=527a3958&scoped=true"
import script from "./messageIndex.vue?vue&type=script&lang=js"
export * from "./messageIndex.vue?vue&type=script&lang=js"
import style0 from "./messageIndex.vue?vue&type=style&index=0&id=527a3958&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a3958",
  null
  
)

export default component.exports